import auth from '../utils/auth'
import * as signalR from '@microsoft/signalr';

const tokenRequest = {
  scopes: ['api://3243f2bc-0c86-4a68-80c4-6f041c855ffa/User.ReadWrite'],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
}

export default {
    async buildHub(){
        var syncHub = process.env.VUE_APP_TDM_SYNC_URL + "/synchub";
        const accessToken = await auth.acquireToken(tokenRequest);
        let instance = new signalR.HubConnectionBuilder()
                .withUrl(syncHub, signalR.HttpTransportType.WebSockets ,{ accessTokenFactory: () => accessToken, withCredentials: false})
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Information)
                .build();

        return instance;
    } 
}